export const formatAppliedFilters = (appliedFilters = [], labels) => {
	return appliedFilters.map(obj => {
		const { id, label, values } = obj;
		const formattedFilter = obj;
		const idsToFormat = [
			'geoRadius',
			'normalExteriorColor',
			'normalInteriorColor'
		];
		if (idsToFormat.includes(id)) {
			formattedFilter.values = values.map(value => {
				const { label: filterLabel, value: filterValue } = value;
				let displayedValue = filterLabel;
				if (id === 'geoRadius') {
					const { geoZip } = window.DDC.InvData.getGeoData()
						? window.DDC.InvData.getGeoData()
						: window.DDC.InvData.urlParams;
					displayedValue = `${filterValue} ${labels.MILES} ${labels.FROM_LOWERCASE} ${geoZip}`;
				}
				return {
					label:
						id === 'geoRadius'
							? displayedValue
							: `${label}: ${displayedValue}`,
					value: filterValue
				};
			});
		}
		return formattedFilter;
	});
};

/**
 * Returns a string of joined applied filter value labels separated by a comma.
 *
 * @param {array} appliedFilters An array consisting of `window.DDC.InvData.getAppliedFilters()` data
 *
 * @returns {string} label text of filter values joined by a comma
 */
export const getFilterLabels = (appliedFilters = []) => {
	const labels = [];

	if (appliedFilters.length) {
		const values = appliedFilters.map(obj => obj.values);
		[].concat(...values).map(value => labels.push(value.label));
	}

	return labels.join(', ');
};
